//
// Module for the File Download Index view
//
rs.module("framework/content/filedownload/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl, gridUpdateCompleteCallback) {

            var repositoryDropdown = $.js(jsSelectors.filter).js(jsSelectors.repositoryDropdown);
            var loadingSpinner = $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner);

            // Hook up change event on process type dropdown to reload the grid data via ajax
            repositoryDropdown.change(function () {

                loadingSpinner.show();

                // Update grid
                gridModule.update(
                    backendUrl,
                    { selectedRepositoryKey: this.value },
                    lrsGridApi.agGridApi,
                    function done(result) {

                        // Trigger the grid update complete call back, if provided
                        if (gridUpdateCompleteCallback != null) {
                            gridUpdateCompleteCallback(result, lrsGridApi.agGridApi);
                        }
                        
                        loadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);